import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "../../../environments/environment";

export const authConfig: AuthConfig = {
    issuer: environment.oauth.issuer,
    redirectUri: window.location.origin + '/callback',
    clientId: environment.oauth.clientId,
    responseType: 'code',
    scope: 'openid profile email mail me.read fr:idm:*',
    silentRefreshRedirectUri:window.location.origin + '/callback',
    useSilentRefresh: true,
    silentRefreshTimeout: 5000,
    timeoutFactor: 0.75,
    sessionChecksEnabled: false,
    clearHashAfterLogin: true,
    skipIssuerCheck: true,
    requireHttps: false,
    strictDiscoveryDocumentValidation: false
  };